import 'whatwg-fetch';

export class SvgSprite {
    constructor(svgURL: string) {
        const sprite = document.querySelector('#svgSprite');
        if (!sprite) {
            window.fetch(svgURL)
                .then(response => {
                    if (response.status !== 200) {
                        throw "SVG sprite load failed. Status code: " + response.status;
                    } else {
                        return response.text();
                    }
                })
                .then(svg => this.injectSvg(svg));
        }
    }

    injectSvg(data) {
        if (data !== undefined) {
            const newDiv = document.createElement('div');
            newDiv.innerHTML = data;
            document.body.insertBefore(newDiv, document.body.childNodes[0]);
        }
    }
}